export default "__VITE_ASSET__lCDIGDgFWBJBJL0IyOiUKw__"